import { render, staticRenderFns } from "./fansRank.vue?vue&type=template&id=c212cdf0&scoped=true"
import script from "./fansRank.vue?vue&type=script&lang=js"
export * from "./fansRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c212cdf0",
  null
  
)

export default component.exports